import $ from 'jquery';
import { loaderService } from './loader-services';

export const renditionAjaxStart = () => {
    // Run when the first AJAX request begins
    // No matter how many ajax calls for one page, the ajax start only run once 
    $(document).ajaxStart(function() {  
        loaderService.showSpinner();        
    });
}

export const renditionAjaxStop = () => {
    // Is called whenever all ajax requests complete. 
    // Unlike ajax complete, it won't be called if there is still one request on progress  
    $(document).ajaxStop(function() {
        loaderService.hideSpinner();          
    });
}